"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCompleteWrapper = exports.AutoCompleteListDiv = exports.KeywordItem = exports.AutoCompleteKeywordDiv = exports.AutoCompleteSpacerDiv = exports.AutoCompleteAloneDiv = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.AutoCompleteAloneDiv = styled_components_1.default.div `
  position: relative;

  width: 100%;
  height: auto;

  margin-top: 12px;
  margin-bottom: 12px;

  background-color: #fff;

  .Auto__Alone__Button {
    display: flex;
    align-items: center;
    gap: 15px;

    width: 100%;
    height: 42px;

    padding-left: 20px;
    padding-right: 20px;
  }

  .Auto__Alone__Content {
    text-align: left;
    font-size: 0.9375rem;
    letter-spacing: -0.0469rem;
    color: #2c87f1;

    .Auto__Alone__GuideText {
      color: #202020;
    }
  }

  .Auto__Alone__Button__Img {
    width: 15px;
    height: 15px;
  }

  &:hover {
    background-color: #eaeaea;

    .Vertical__Focus {
      background-color: #0ac7ce;
    }
  }

  button:focus {
    background-color: #eaeaea;

    .Vertical__Focus {
      background-color: #0ac7ce;
    }
  }
`;
exports.AutoCompleteSpacerDiv = styled_components_1.default.div `
  width: 100%;
  padding-bottom: 10px;
`;
exports.AutoCompleteKeywordDiv = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-direction: column;
`;
exports.KeywordItem = styled_components_1.default.div `
  width: 100%;
  height: 42px;

  &:hover, &:focus {
    background-color: #eaeaea;

    .Vertical__Focus {
      background-color: #0ac7ce;
    }
  }

  .Recent__Query__Item {
    display: flex;
    align-items: center;
    gap: 14px;

    width: 100%;
    height: 100%;

    padding: 0 20px;
  }

  .Recent__Query__Item__Img {
    position: relative;
    top: 1px;

    width: 15px;
    height: 15px;
  }

  .Recent__Search__Query__Content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;

    text-align: left;
    font-size: 0.9375rem;
    letter-spacing: -0.0469rem;
    color: #202020;
  }
`;
exports.AutoCompleteListDiv = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-direction: column;
`;
exports.AutoCompleteWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
